import { Badge, BadgeProps } from "@mui/material";
import { uiColors } from "@v2/lib/color";

export default function StyledBadge({ size, children, anchorOrigin, ...rest }: BadgeProps & { size?: 'small' | 'large' }) {
    return <Badge {...rest}

        anchorOrigin={anchorOrigin ?? {
            vertical: 'top',
            horizontal: 'left',
        }}
        // className="en-num"
        sx={{
            '& .MuiBadge-badge': {
                fontSize: size === "large" ? 14 : 10,
                // height: 18, width: 18,
                // minWidth: 'unset',
                lineHeight: 1.1,
                zIndex: 100,
                top: 5,
                // border: '2px solid #fff',
                // boxShadow: 'unset',
                color: '#fff',
                '&::before': {
                    content: '""',
                    borderRadius: '50%',
                    position: 'absolute',
                    top: size === "large" ? -6 : 1,
                    zIndex: -1,
                    bgcolor: uiColors.primary,
                    border: '3px solid #fff',
                    height: size === "large" ? 24 : 18,
                    width: size === "large" ? 24 : 18
                }
            }
        }}
    >{children}</Badge>
}